// extracted by mini-css-extract-plugin
export var billingAddress = "_rd-f";
export var contactInfo = "_rd-c";
export var customerInfoContainer = "_rd-b";
export var customerInfoRow = "_rd-9";
export var customerInfoSection = "_rd-a";
export var fullWidthDividerMobile = "_rd-g";
export var imageContainer = "_rd-1";
export var paymentMethod = "_rd-d";
export var priceText = "_rd-6";
export var priceTextMobile = "_rd-7";
export var product = "_rd-0";
export var productImage = "_rd-2";
export var productInfo = "_rd-4";
export var productTitle = "_rd-8";
export var quantityBadge = "_rd-3";
export var quantityText = "_rd-5";
export var shippingAddress = "_rd-e";